import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {
    TextInput, NumberInput, BooleanInput
} from 'react-admin';
import {useTranslation} from "react-i18next";


function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="description" label={t('admin.description')}/>
            <BooleanInput source="isDefault" label={t('admin.isDefault')}/>
            <NumberInput source="order" label={t('admin.order')}/>
            <TextInput source="code" label={t('admin.code')} disabled/>
            <NumberInput source="duration" label={t('admin.duration')}/>
        </EditGuesser>
    )
}

export default Edit
